module.exports = __webpack_public_path__ + "img/map_large.e9550f39.png";